import { render } from "./msgRead.vue?vue&type=template&id=5a696f10&scoped=true"
import script from "./msgRead.vue?vue&type=script&lang=js"
export * from "./msgRead.vue?vue&type=script&lang=js"

import "@/styles/striNew.css?vue&type=style&index=0&lang=css"
import "./msgRead.vue?vue&type=style&index=1&id=5a696f10&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a696f10"]])

export default __exports__